import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { DashboardCardConfigModel } from '../../models/dashboard-card-config.model';
import { DashboardComponentTypeEnum } from '../../models/enums/dashboard-component.enum';
import { LayoutKeyEnum } from '../../models/enums/layout-key.enum';
import { UserSessionService } from '../../services/user-session.service';

@Component({
    selector: 'sl-general-meeting-overview',
    templateUrl: './general-meeting-overview.component.html',
    styleUrls: ['./general-meeting-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralMeetingOverviewComponent implements OnInit {
    LayoutKeyEnum = LayoutKeyEnum;
    roleId: number;

    dashboardConfiguration: DashboardCardConfigModel[] = [
        {
            type: DashboardComponentTypeEnum.GeneralMeetingSettings,
            x: 0,
            y: 0,
            width: 7,
            height: 8
        },
        {
            type: DashboardComponentTypeEnum.Presence,
            x: 0,
            y: 8,
            width: 7,
            height: 10
        },
        {
            type: DashboardComponentTypeEnum.GeneralMeetingAgenda,
            x: 7,
            y: 0,
            width: 15,
            height: 18
        }
    ];

    private readonly userSessionService = inject(UserSessionService);

    ngOnInit(): void {
        this.roleId = this.userSessionService.roleId;
    }
}
